<template>
  <div class="wrap-number">
    <div v-if="strategy" class="wrapp">
      <template v-for="(time, i) in t-1">
        <p :key="i" class="number-attempts">
          <span class="number-attempt">{{ $t('autocaller_v2.campaign.field.attempt') }} №{{ i+2 }}</span>
          <input-number
            class="ml-3 mr-2"
            :min="1" :max="999"
            :value="strategy[i]"
            @input="input($event, time)"
          />
          <span>{{ $t('autocaller_v2.campaign.field.time') }}</span>
        </p>
      </template>
    </div>
    <span v-else class="wrapp">
      <template v-for="time in times - 1">
        <span :key="time" class="number-attempts">
          <span class="number-attempt">{{ time }}</span>
          <label><input-number :min="1" @input="input($event, time)" /><span>{{ $t('autocaller_v2.campaign.field.time') }}</span></label>
        </span>
      </template>
    </span>
  </div>
</template>
<script>
  export default {
    props: {
      times: {
        type: [Number, String],
        default: null
      },
      strategy: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      t() {
        if (this.times > this.strategy.length) {
          return this.times;
        }
        return this.strategy.length;
      }
    },
    watch: {
      t: {
        deep: true,
        handler: function () {
          for (let i = 0; this.strategy.length > i; i++) {
            if (!this.strategy[i]) {
              this.$emit('input', 1, i + 1);
            }
          }
        }
      }
    },
    methods: {
      input(val, i) {
        this.$emit('input', val, i);
      }
    }
  };
</script>

<style lang="scss">
  .number-attempts {
    display: flex;
    align-items: center;
  }

  .number-attempt {
    width: 92px;
  }
</style>
